{
  "common": {
    "not_specified": "Не указано",
    "not_specified_she": "Не указана",
    "not_specified_he": "Не указан",
    "cancel": "Отмена",
    "save": "Сохранить",
    "change_order": "Изменить порядок"
  },
  "offline": {
    "snapshot_message": "Нет связи с сервером. Показаны данные на {{date}}; изменения недоступны.",
    "unavailable_message": "Нет связи с сервером, и эта страница ранее не была сохранена."
  },
  "columns_filters": {
    "all_requests": "Все заявки",
    "calendar": {
      "month": "Месяц (31 день)",
      "week": "Неделя (7 дней)",
      "year": "Год",
      "yesterday_today_range": "Вчера-Сегодня"
    },
    "choose_request_status": "Выберите статус заявки",
    "request_status": "Статус",
    "contract": "Договор",
    "releaseTime": "Когда(время)",
    "releaseDate": "Когда(дата)",
    "releaseDatePeriod": "Когда(дата и время)",
    "delivery_address": "Адрес выдачи или название",
    "delivery_name": "Салон",
    "filters": "Фильтры",
    "my_requests": "Мои заявки",
    "not_assigned": "Не назначен",
    "request_number": "Заявка",
    "project_number": "№ проекта",
    "requests_selected_count": "Выбрано заявок:",
    "select_all_requests": "Выбрать все",
    "select_installer": "СЛС",
    "select_quality_status_title": "Статус ОКК",
    "subj_name": "Лизингополучатель",
    "car": "ПЛ",
    "car_plant_number": "Госномер",
    "vin": "VIN номер",
    "request_product": "Товары и услуги",
    "created_at": "Дата создания",
    "updated_at": "Дата обновления",
    "docs": "Е-ПТС / ФОТО ПЛ / АПП к ДЛ / АПП к ДКП",
    "request": "Заявка",
    "requestType": "Тип заявки",
    "leasing_subject": "Предмет лизинга",
    "select_counterparty": "Заказчик",
    "created_via_api": "Создано через API",
    "inventory_doc_uploaded": "Опись подгружена",
    "leasing_product": "Лизинговый продукт",
    "extended_program": "Расширенная программа",
    "manufacturer_company": "Изготовитель (компания)",
    "manufacturer_country": "Изготовитель (cтрана)",
    "is_for_create_request": "Заявка - Запрос на создание заявок",
    "obd_status": "Статус OBD",
    "yes": "Да",
    "no": "Нет",
    "installer_groups": "Группы",
    "installers": "СЛС",
    "products": "Товары и услуги",
    "group": "Группа",
    "apply": "Применить"
  },
  "core": {
    "no_permission": {
      "exit_from_app": "выйти из системы",
      "message": "У вас нет необходимых прав! Попробуйте выбрать другой раздел или обратитесь к администратору.",
      "title": "Нет доступа",
      "you_can_also": "Вы также можете",
      "no_access_to_outkeep_app": "У вас нет доступа к приложению Outkeep"
    },
    "person_required": {
      "title": "Нет доступа к приложению",
      "message": "Для доступа к приложению необходимо привязать физическое лицо. Обратитесь к администратору.",
      "logout": "Выйти"
    },
    "pwa": {
      "install_app_btn": "Установить приложение",
      "install_app_instructions_title": "Инструкция по установке приложения",
      "install_app_instructions_step1": "В нижней панели браузера нажмите кнопку «Поделиться» ('Share') (иконка с квадратом и стрелкой вверх).",
      "install_app_instructions_step2": "В списке действий выберите «На экран “Домой”» ('Add to Home Screen').",
      "install_app_instructions_step3": "Задайте название приложения.",
      "install_app_instructions_step4": "Нажмите «Добавить» ('Add') – и иконка появится на рабочем столе."
    },
    "services": {
      "request_addresses_service": {
        "reset_address_dialog_cancel": "Отмена",
        "reset_address_dialog_confirm": "Да, сбросить",
        "reset_address_dialog_label": "Вы действительно хотите сбросить актуальный адрес выдачи?",
        "reset_address_error": "Произошла ошибка при сбросе адреса выдачи",
        "reset_address_error_multi_all": "Произошла ошибка при сбросе всех адресов выдачи",
        "reset_address_error_multi_some": "Произошла ошибка при сбросе одного из адресов выдачи",
        "reset_address_error_permission": "Недостаточно прав для сброса актуального адреса выдачи",
        "reset_address_success": "Актуальный адрес выдачи сохранён! Выполняем повторную загрузку изменённых заявок",
        "set_address_dialog_cancel": "Отмена",
        "set_address_dialog_confirm": "Подтверждаю",
        "set_address_dialog_label": "Вы действительно готовы подтвердить адрес выдачи? Изменить его будет уже нельзя.",
        "set_address_error": "Произошла ошибка при сохранении адреса выдачи",
        "set_address_error_multi_all": "Произошла ошибка при сохранении всех адресов выдачи",
        "set_address_error_multi_some": "Произошла ошибка при сохранении одного из адресов выдачи",
        "set_address_error_warning": "Внимание!",
        "set_address_error_403": "Подтвердить актуальный адрес выдачи может только специалист по сопровождению или другое уполномоченное лицо.",
        "set_address_success": "Актуальный адрес выдачи сохранён! Выполняем повторную загрузку изменённых заявок"
      },
      "request_deal_details_service": {
        "confirm_dialog_no": "Нет",
        "confirm_dialog_yes": "Да",
        "error": "Ошибка",
        "error_no_permissions_to_edit_all_deal_details": "Некоторые выбранные заявки имеют детали сделки, но для их редактирования у вас не хватает прав. Снять выделение с недоступных для редактирования заявок и продолжить работу с деталями сделок?",
        "error_no_selected_deal_details_left": "Не осталось выделенных заявок, модальное окно групповых действий закрыто",
        "error_saving_deal_details": "Произошла ошибка при сохранении данных деталей сделки",
        "is_current_user_installer_in_requests_without_deal_details": "Некоторые выбранные заявки не имеют описаний сделок, а создавать их может только СЛС заявки. Вы хотите снять выделение с недоступных заявок и продолжить редактирование описаний сделок?"
      },
      "request_products_service": {
        "dialog_cancel_completion": "Вы действительно хотите отменить выполнение \"{{productName}}\"",
        "dialog_cancel_completion_yes": "Да, отменить",
        "dialog_cancel_forcibly_completion": "Вы действительно хотите отменить принудительное выполнение?",
        "dialog_cancel_forcibly_completion_no": "Нет",
        "dialog_cancel_forcibly_completion_yes": "Да, отменить",
        "dialog_completion": "Вы действительно хотите указать \"{{productName}}\" выполненным?",
        "dialog_completion_no": "Нет",
        "dialog_completion_yes": "Да, выполнено",
        "error": "Ошибка",
        "error_cancel_forcibly_completion": "Для услуги \"{{productName}}\" не удалось отменить принудительное выполнение: необходимые условия так и не были выполнены!",
        "error_cancel_forcibly_completion_requirements_not_met": "Не удалось отменить принудительное выполнение: необходимые условия так и не были выполнены",
        "error_cannot_close_products_not_valid_required_fields_or_forcibly_closed": "Не удалось закрыть продукты: {{failedProductsToClose}}! Так как они не прошли проверку обязательных полей или были закрыты принудительно",
        "error_something_went_wrong": "Что-то пошло не так при закрытии продуктов! Попробуйте ещё раз",
        "success_cancel_forcibly_completion": "Принудительное выполнение успешно отменено",
        "success_products_status_changed": "Статус продуктов успешно изменён",
        "success_status_changed": "Статус продукта успешно изменён"
      },
      "request_ratings_service": {
        "error_getting_ratings": "Случилась ошибка при получении всех рейтингов!"
      },
      "request_statuses_service": {
        "actual_delivery_address_not_confirmed_error_message": "актуальный адрес выдачи не подтвержден.",
        "all_selected_requests_cannot_be_changed_error": "Ни одна из выбранных заявок не может быть переведена в данный статус",
        "change_status_success": "Статусы назначены; Выполняем повторную загрузку изменённых заявок",
        "change_statuses": "Назначение статусов",
        "device_install_quality_failed_error_message": "устройства не прошли проверку качества установки (дождитесь завершения проверки, в случае ошибки перезапустите проверку).",
        "dialog_change_status": "Вы уверены что хотите изменить статус?",
        "dialog_change_status_no": "Нет",
        "dialog_change_status_yes": "Да",
        "dialog_not_all_requests_can_be_changed": "Некоторые заявки не могут быть переведены в данный статус! Вы хотите перевести только доступные заявки, а остальные убрать из выделения?",
        "dialog_not_all_requests_can_be_changed_no": "Нет",
        "dialog_not_all_requests_can_be_changed_yes": "Да",
        "error_happened_tell_devs": "Произошла ошибка! Сообщите разработчикам",
        "from_status": "из статуса",
        "in_status": "в статус",
        "no_cancellation_initiator_error": "Для смены статуса на \"Отменена\" необходимо указать инициатора отмены.",
        "no_deal_details": "отсутствуют описания сделки",
        "no_primary_documentation": "в описании сделки не указана первичная документация",
        "no_reason_query_to_edit_initiator_error": "Для смены статуса на \"Запрос на редактирование\" необходимо указать причину запроса на редактирование.",
        "no_release_date_for_check_error_message": "Нельзя отправить на проверку заявку без даты выдачи",
        "no_release_datetime_error_message": "отсутствует дата и время выдачи.",
        "only_creator_can_change_status_from_new": "Статус новой заявки может изменить только её создатель.",
        "status_change_forbidden_for_customer": "изменить статус выполненной или выданной заявки может только исполнитель. Для изменения обратитесь к вашему менеджеру.",
        "only_current_sls_can_change_deal_details": "Сейчас детали сделки не добавлены, и только СЛС текущей заявки может добавить эти детали и перевести заявку в этот статус.",
        "products_are_not_completed_error_message": "услуги не были помечены как завершенные.",
        "reason_query_to_edit_request": "Причина запроса на редактирование:",
        "release_date_in_past_for_check_error_message": "Нельзя отправить на проверку заявку с прошедшей датой выдачи",
        "release_time_in_future_error_message": "дата выдачи в будущем",
        "today": "Сегодня",
        "unable_change_request": "Невозможно перевести заявку",
        "unable_change_status": "Невозможно перевести заявку в статус",
        "warn": "Внимание!"
      },
      "warehouse_service": {
        "check_sold_forbidden": "Вам нельзя списывать данное устройство",
        "check_sold_may_be_problems": "Возможно, будут проблемы со списанием устройства при закрытии заявки. Причина:",
        "check_sold_not_found": "Устройство не найдено на складе",
        "check_sold_undefined_error": "Неизвестная ошибка списания устройства",
        "sell_recover_error_no_rights": "Не удалось списать/восстановить устройство со склада: у вас нет прав.",
        "sell_recover_error_not_found": "Не удалось списать/восстановить устройство со склада: не найдено на складе.",
        "sell_recover_error_undefined_error": "Не удалось списать/восстановить устройство со склада: неизвестная ошибка."
      },
      "x_alert_service": {
        "dialog_no": "Отмена",
        "dialog_yes": "Да"
      }
    },
    "interceptors": {
      "http_error": {
        "default_title": "Ошибка",
        "status_label": "Статус",
        "no_connection_title": "Нет соединения",
        "no_connection_message": "Проверьте подключение к интернету",
        "bad_request_title": "Неверный запрос",
        "bad_request_message": "Проверьте введенные данные",
        "forbidden_title": "Доступ запрещен",
        "forbidden_message": "У вас нет прав для выполнения этой операции",
        "not_found_title": "Не найдено",
        "not_found_message": "Запрашиваемый ресурс не найден",
        "server_error_title": "Ошибка сервера",
        "server_error_message": "Внутренняя ошибка сервера. Попробуйте позже",
        "bad_gateway_title": "Плохой шлюз",
        "bad_gateway_message": "Сервер получил недопустимый ответ от вышестоящего сервера",
        "service_unavailable_title": "Сервис недоступен",
        "service_unavailable_message": "Сервер временно недоступен. Попробуйте позже",
        "unknown_error": "Неизвестная ошибка",
        "unexpected_error": "Произошла непредвиденная ошибка"
      }
    },
    "sidebar": {
      "all": "Заявки",
      "as_system": "Как в системе",
      "dark": "Темная",
      "feedback_btn": "Отзыв о работе",
      "light": "Светлая",
      "logout": "Выход",
      "main_btn_title": "Меню",
      "repossession": "Заявки с изъятием",
      "workflows": "Регламенты",
      "theme": "Тема",
      "today": "Заявки",
      "docflow": "Документооборот",
      "payroll": "Начисления",
      "warehouse": "Склад(бета)",
      "requests_distribution": "Распределение заявок",
      "requests_registry": "Реестр Логиста",
      "group_requests": "Заявки",
      "group_time_management": "Тайм менеджмент Логистов"
    },
    "text_copier": {
      "copied": "Скопировано",
      "not_found_to_copy": "Нечего копировать"
    },
    "time_picker": {
      "cancel": "Отмена",
      "save": "Сохранить",
      "keyboard_edit_hint": "Используйте стрелки ⇅ или цифры для ввода времени"
    }
  },
  "contractor_filter_dialog": {
    "hint": "Фильтр по специалистам по установке СО: выберите исполнителей и нажмите «Применить»",
    "contractors_placeholder": "Выберите исполнителя ...",
    "subdivision_placeholder": "Выберите подразделение ...",
    "apply": "Применить",
    "reset": "Сбросить"
  },
  "owner_filter_dialog": {
    "hint": "Фильтр по заказчикам контрагентам: выберите контрагента и нажмите «Применить»",
    "owner_placeholder": "Выберите заказчика ...",
    "apply": "Применить",
    "reset": "Сбросить"
  },
  "filters_buttons": {
    "contractor": "Исполнитель",
    "owner": "Заказчик",
    "without_contractor": "Без исполнителя",
    "assigned_to_me": "Заявки для меня",
    "hide_completed": "Скрыть выполненные",
    "in_work": "В работе",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "clear_all": "Очистить все",
    "apply": "Применить",
    "statusId": "СТ",
    "requestType": "Тип заявки",
    "installerId": "СЛС",
    "productsIds": "Товары и услуги",
    "installerGroup": "ГР",
    "counterpartyOwnerId": "ЗК",
    "releaseTime": "ВремяВыдачи",
    "releaseDate": "ДатаВыдачи",
    "releaseDatePeriod": "ДатаВремяВыдачи",
    "requestNumber": "НЗ",
    "projectNumber": "НП",
    "contract": "ДГ",
    "subjName": "ЛП",
    "deliveryAddress": "АВ",
    "deliveryName": "САЛ",
    "qualityControlStatus": "ОКК",
    "carModelAndBrand": "ММ",
    "carPlantNumber": "ГН",
    "vin": "VIN",
    "createdViaApi": "Создано через API",
    "inventoryDocUploaded": "Опись подгружена",
    "leasingProduct": "Лизинговый продукт",
    "extendedProgram": "Расширенная программа",
    "manufacturerCompany": "Изготовитель (компания)",
    "manufacturerCountry": "Изготовитель (cтрана)",
    "isForCreateRequests": "Заявка - Запрос на создание заявок",
    "obdStatus": "Статус OBD",
    "not_set": "Не назначен",
    "true": "Да",
    "false": "Нет"
  },
  "group_actions": {
    "actions": {
      "add_deal_details": "Добавить описание",
      "change_status": "Изменить статус",
      "change_release_date": "Изменить дату и время заявки",
      "change_installer_assignment": "Назначить СЛС",
      "confirm_delivery_address": "Подтвердить актуальный адрес выдачи",
      "ratings": "Внутренние оценки",
      "reset_delivery_address": "Сбросить актуальный адрес выдачи",
      "upload_files": "Загрузить файлы"
    },
    "actual_address": {
      "actual_address": "Актуальный адрес",
      "check_on_map": "Проверить на карте",
      "checked": "Проверен",
      "confirm": "Подтвердить",
      "differs": "(отличается от заявленного)",
      "no_rights_to_change": "У вас отсутствуют права на изменение адреса",
      "validation_required": "Нуждается в проверке"
    },
    "header": {
      "selected": "Выбранные"
    },
    "installer_assignment": {
      "mixed_owners": "Групповое назначение СЛС доступно только для заявок одного заказчика",
      "no_selected_requests": "Сначала выберите заявки для назначения СЛС"
    },
    "release_date": {
      "apply": "Применить",
      "date": "Планируемая дата выдачи",
      "hour": "Часы",
      "incomplete_time": "Выберите и часы, и минуты",
      "minute": "Минуты",
      "transfer_reason": "Причина переноса",
      "transfer_reason_required": "Выберите причину переноса",
      "time": "Планируемое время выдачи"
    },
    "date_time_transfer": {
      "reason_dialog": {
        "title": "Выберите причину переноса",
        "reason_label": "Причина переноса",
        "cancel": "Отмена",
        "confirm": "Подтвердить"
      }
    },
    "files_upload": {
      "category_title": "Категория файлов",
      "category_placeholder": "Выберите категорию",
      "owner_categories": "От заказчика",
      "contractor_categories": "От исполнителя",
      "files_title": "Файлы",
      "files_hint": "До 150 файлов, каждый не более 50 МБ",
      "distribute": "Распределить по имени",
      "drop_title": "Перетащите файлы сюда",
      "drop_hint": "или нажмите, чтобы выбрать",
      "remove_file": "Убрать файл",
      "requests_placeholder": "Заявки",
      "select_all": "Выбрать все",
      "clear_all": "Убрать все",
      "distribution_matched": "Заявка найдена по имени файла",
      "distribution_none": "Совпадений нет — оставлены все допустимые заявки",
      "distribution_ambiguous": "Найдено несколько совпадений. Выберите заявки вручную.",
      "uploaded": "загружен",
      "upload_error": "ошибка",
      "retry_failed": "Повторить ошибки",
      "upload": "Загрузить файлы",
      "close_preview": "Закрыть",
      "preview_image_alt": "Предпросмотр файла",
      "file_size_kb": "{{size}} КБ",
      "file_size_mb": "{{size}} МБ",
      "missing_requests": "Не удалось получить {{count}} выбранных заявок. Загрузка заблокирована, чтобы не пропустить часть выбранного набора.",
      "success": "Все файлы успешно загружены",
      "errors": {
        "load": "Не удалось загрузить данные для загрузки",
        "max_files": "Можно добавить не более {{maxFiles}} файлов",
        "empty_file": "Файл «{{name}}» пуст",
        "file_too_large": "Файл «{{name}}» превышает ограничение 50 МБ",
        "upload": "Не удалось загрузить {{failed}} из {{total}}"
      }
    },
    "selected": {
      "contract": "Договор",
      "project": "Проект",
      "request": "Заявка",
      "selected_requests": "Выбранные заявки"
    },
    "status": {
      "apply": "Применить",
      "no_access": "У вас нет доступа к этому разделу"
    },
    "title": {
      "add_deal_details": "Добавить описание",
      "change_status": "Изменить статус",
      "comments": "Комментарии",
      "confirm_actual_delivery_address": "Подтвердить актуальный адрес выдачи",
      "delivery_address": "Адрес выдачи",
      "edit_requests": "Редактировать заявки",
      "installer_assignment": "Назначение СЛС",
      "release_date": "Изменить дату и время заявки",
      "ratings": "Внутренние оценки",
      "status": "Статус",
      "files": "Файлы",
      "upload_files": "Загрузка файлов"
    }
  },
  "date_time_transfer": {
    "reason_dialog": {
      "title": "Выберите причину переноса",
      "reason_label": "Причина переноса",
      "cancel": "Отмена",
      "confirm": "Подтвердить"
    }
  },
  "obd_statuses": {
    "1": "Есть разъем OBD2",
    "2": "Нет доступа / возможности поиска разъема",
    "3": "Есть диагностический разъем, но не OBD2",
    "4": "Нет диагностического разъема"
  },
  "obd_success_read": {
    "1": "Считано",
    "2": "Не считано"
  },
  "pagination": {
    "entries_per_page": "Записей на странице",
    "of": "из",
    "page": "Страница",
    "requests_per_page": "Записей на странице:"
  },
  "position_definer": {
    "auto_detect_position": "Определить позицию автоматически",
    "cancel": "Отмена",
    "help_text_error": "Не удалось определить координаты автоматически",
    "help_text_success": "Координаты успешно определены",
    "i_am_on_object_place": "Я нахожусь рядом с объектом, и координаты объекта равны моим\n        координатам",
    "latitude": "Широта",
    "latitude_example": "Например, 55.755814",
    "longitude": "Долгота",
    "longitude_example": "Например, 37.617635",
    "specify": "Указать"
  },
  "profile_page": {
    "title": "Настройки профиля",
    "email_label": "E-Mail*",
    "email_placeholder": "Введите адрес",
    "full_name_label": "Полное Имя",
    "change_password": "Сменить пароль",
    "cancel_change_password": "Отменить смену пароля",
    "new_password_label": "Введите новый пароль",
    "new_password_placeholder": "Новый пароль",
    "new_password_error_too_short": "Пароль должен содержать не менее 4 символов",
    "confirm_new_password_label": "Подтвердите новый пароль",
    "confirm_new_password_placeholder": "Подтверждение",
    "confirm_password_error_mismatch": "Пароли не совпадают",
    "set_new_password_button": "Задать новый пароль",
    "save_changes": "Сохранить изменения",
    "reset_settings": "Сбросить настройки",
    "logout": "Выйти из аккаунта"
  },
  "docflow_page": {
    "title": "Документооборот"
  },
  "payroll_page": {
    "title": "Начисления"
  },
  "warehouse_page": {
    "title": "Склад(бета)"
  },
  "logist_time_management": {
    "city_filter": {
      "clear_selection": "Снять выбор",
      "select_all": "Выбрать все"
    },
    "date_sections": {
      "collapse": "Свернуть дату {{date}}",
      "expand": "Развернуть дату {{date}}"
    },
    "personal_note": {
      "add": "Заметка",
      "conflict": "Заметка изменилась",
      "failed": "Не сохранено",
      "group_count": "Заметок: {{count}}",
      "load_current": "Загрузить актуальную",
      "overwrite": "Перезаписать",
      "placeholder": "Общая заметка к заявке или брони",
      "retry": "Повторить",
      "saved": "Сохранено",
      "saving": "Сохранение...",
      "title": "Общая заметка",
      "updated_by": "{{author}}, {{date}}"
    },
    "requests_distribution_page": {
      "address": "Адрес",
      "assignment_error_message": "Заявки остались в пуле распределения. Попробуйте назначить их еще раз.",
      "assignment_error_title": "Не удалось назначить логиста",
      "assignment_conflict_title": "Заявка уже перемещена",
      "assignment_conflict_message": "Загружены актуальные данные. Повторите назначение.",
      "clear_selection": "Снять выбор",
      "cities_filter": "Города логиста",
      "counterparty": "Заказчик",
      "date": "Дата",
      "busy_description": "Изменения выполняются. Дождитесь завершения операции.",
      "busy_title": "Идет обновление",
      "empty_logists": "Нет доступных логистов",
      "empty_pool": "Нет заявок для распределения",
      "found": "Найдено: {{count}}",
      "group": "Группировать",
      "group_by": "Группировка",
      "grouping_fields": {
        "address": "Адрес",
        "contract": "Договор",
        "counterparty": "Заказчик",
        "date": "Дата",
        "lessee": "ЛП",
        "number": "Заявка",
        "ownerLogist": "Логист заказчика",
        "projectNumber": "Проект",
        "supplier": "Поставщик",
        "supportManager": "Менеджер",
        "time": "Время"
      },
      "group_row": "Группа: {{count}}",
      "import_cancel": "Отмена",
      "import_confirm": "Подтвердить импорт",
      "import_created_rows": "Создано записей",
      "import_done": "Готово",
      "import_dry_run": "Проверить файл",
      "import_dry_run_paste": "Проверить вставленные данные",
      "import_error": "Не удалось выполнить импорт файла",
      "import_error_paste_not_supported": "Этот шаблон не поддерживает вставку данных. Пожалуйста, загрузите файл.",
      "import_file": "Файл",
      "import_source": "Источник",
      "import_source_file": "Загрузить файл",
      "import_source_paste": "Вставить таблицу",
      "import_paste_label": "Содержимое таблицы",
      "import_paste_placeholder": "Вставьте скопированные строки из таблицы",
      "import_paste_hint": "Вставьте табличные данные, скопированные из Excel или другой таблицы",
      "import_force_update_date_time": "Принудительно обновлять дату и время при совпадении",
      "import_choose_file": "Выберите файл",
      "import_open": "Импорт",
      "import_preview_empty": "Нет строк для предпросмотра",
      "import_preview_field_contract": "Договор",
      "import_preview_field_counterparty_id": "Заказчик",
      "import_preview_field_date": "Дата",
      "import_preview_field_delivery_address": "Адрес",
      "import_preview_field_delivery_name": "Салон",
      "import_preview_field_extra": "Доп. поля",
      "import_preview_field_project_number": "Номер проекта",
      "import_preview_field_row_number": "Номер строки",
      "import_preview_field_subj_name": "ЛП",
      "import_preview_field_time": "Время",
      "import_preview_title": "Предварительный результат",
      "import_preview_first_rows": "Показаны только первые 100 строк",
      "import_processed_rows": "Обработано строк",
      "import_selected_file": "Выбранный файл",
      "import_skipped_reason_contract": "\"Договор\" - обязательное поле",
      "import_skipped_reason_counterparty": "Не удалось определить заказчика",
      "import_skipped_reason_date": "\"Дата\" - обязательное поле",
      "import_skipped_reason_delivery_address": "\"Адрес\" - обязательное поле",
      "import_skipped_reason_empty": "Строка не содержит данных для импорта",
      "import_skipped_reason_field_missing": "Поле \"{{label}}\" отсутствует или пусто",
      "import_skipped_reason_field_wrong_format": "Поле \"{{label}}\": неверный формат",
      "import_skipped_reason_project_number": "\"Номер проекта\" - обязательное поле",
      "import_skipped_reason_time": "\"Время\" - обязательное поле",
      "import_skipped_empty": "Пропущенных строк нет",
      "import_skipped_row": "Строка {{rowNumber}}: {{reason}}",
      "import_skipped_title": "Пропущенные строки",
      "import_success_title": "Импорт завершен успешно",
      "import_template": "Шаблон",
      "import_templates_error": "Не удалось загрузить шаблоны импорта",
      "import_title": "Импорт заявок из файла",
      "import_updated_intentions": "Обновлено через намерения на изменение",
      "import_updated_non_intentions": "Обновлено без намерений",
      "installers_count": "Число СЛС: {{count}}",
      "logists_filter": "Логисты",
      "logists": "Логистов: {{count}}",
      "number": "Заявка",
      "products": "Товары и услуги",
      "request": "Заявка",
      "reservation": "Резерв",
      "search": "Фильтр",
      "select_all": "Выбрать все",
      "selected": "Выбрано: {{count}}",
      "selected_logists": "Логистов: {{count}}",
      "time": "Время",
      "type": "Тип",
      "without_city": "Без города",
      "realtime_sync": {
        "syncing": "Синхронизация…",
        "synchronized": "Данные синхронизированы",
        "failed": "Не удалось синхронизировать — повторить"
      },
      "ungroup": "Разгруппировать"
    },
    "reservations": {
      "create_button": "Забронировать",
      "delete_single": "Удалить бронь",
      "delete_bulk": "Удалить выбранные брони",
      "confirm_delete_single": "Удалить эту бронь?",
      "confirm_delete_bulk": "Удалить выбранные брони: {{count}}?",
      "send_installer_email_success": "Email отправлен установщику",
      "send_installer_email_error": "Не удалось отправить email установщику",
      "dialog": {
        "cancel": "Отмена"
      }
    },
    "reservations_dialog": {
      "title": "Забронировать время",
      "load_error": "Не удалось загрузить данные для бронирования",
      "submit_error": "Не удалось создать бронь",
      "target_pair_error": "Выберите логиста для города",
      "no_products": "Нет доступных товаров и услуг",
      "fields": {
        "contract": "Номер договора",
        "counterparty": "Заказчик",
        "date": "Дата",
        "delivery_address": "Адрес выдачи",
        "delivery_name": "Поставщик / салон",
        "installer": "СЛС (установщик)",
        "logist": "Логист",
        "products": "Товары и услуги",
        "project_number": "Номер проекта",
        "send_installer_email": "Отправить email установщику",
        "subdivision": "Город логиста",
        "subj_name": "Наименование лизингополучателя",
        "time": "Время"
      },
      "placeholders": {
        "not_selected": "Не выбрано",
        "select": "Выберите"
      },
      "actions": {
        "cancel": "Отмена",
        "submit": "Забронировать"
      }
    },
    "overdue_reservations_dialog": {
      "open_button": "Просроченные брони",
      "title": "Просроченные брони",
      "subtitle": "Брони, дата выдачи которых раньше дефолтного окна ТМЛ.",
      "load_error": "Не удалось загрузить просроченные брони",
      "action_error": "Не удалось выполнить действие с бронями",
      "filters": {
        "search": "Поиск",
        "release_from": "Дата выдачи от",
        "release_to": "Дата выдачи до",
        "created_from": "Создана от",
        "created_to": "Создана до",
        "counterparty": "Заказчик",
        "assigned": "Назначение",
        "all": "Все"
      },
      "assigned_state": {
        "all": "Все",
        "assigned": "Назначенные",
        "unassigned": "Нераспределенные"
      },
      "columns": {
        "date": "Дата выдачи",
        "created": "Создана",
        "counterparty": "Заказчик",
        "subject": "Данные брони",
        "address": "Адрес",
        "assignment": "Назначение"
      },
      "empty": "Просроченных броней не найдено",
      "selected": "Выбрано: {{count}} из {{total}}",
      "transfer_reason": "Причина переноса",
      "transfer_reason_placeholder": "Выберите причину переноса",
      "transfer_reason_required": "Выберите причину переноса",
      "actions": {
        "load_more": "Показать еще",
        "today": "Перенести на сегодня",
        "tomorrow": "Перенести на завтра",
        "delete": "Удалить"
      },
      "confirm": {
        "delete": "Удалить выбранные просроченные брони: {{count}}?",
        "today": "Перенести выбранные брони на сегодня: {{count}}?",
        "tomorrow": "Перенести выбранные брони на завтра: {{count}}?"
      }
    },
    "requests_registry_page": {
      "action_error_message": "Изменения не применены. Попробуйте еще раз.",
      "action_error_title": "Не удалось выполнить действие",
      "conflict": {
        "title": "Данные изменены коллегой",
        "description": "Ваше значение: {{expectedValue}}. Текущее значение: {{currentValue}}.",
        "keep": "Оставить моё",
        "accept": "Принять изменение коллеги",
        "empty_value": "Не выбрано",
        "dnd_title": "Порядок уже изменён",
        "dnd_description": "Загружен актуальный порядок. Повторите перенос."
      },
      "address": "Адрес",
      "apply": "Подтвердить",
      "clear_selection": "Снять выбор",
      "cities_filter": "Города логиста",
      "busy_description": "Изменения выполняются. Дождитесь завершения операции.",
      "busy_title": "Идет обновление",
      "date": "Дата",
      "empty": "Нет распределенных заявок",
      "group_by": "Группировка",
      "group_row": "Группа: {{count}}",
      "grouping_fields": {
        "address": "Адрес",
        "contract": "Договор",
        "counterparty": "Заказчик",
        "date": "Дата",
        "installer": "СЛС",
        "lessee": "Лизингополучатель",
        "number": "Номер",
        "ownerLogist": "Логист",
        "projectNumber": "Проект",
        "supplier": "Поставщик",
        "supportManager": "Менеджер",
        "time": "Время"
      },
      "installer": "СЛС",
      "install_zone": "Зона",
      "install_zone_city": "Город установки",
      "install_zone_city_search": "Поиск города",
      "install_zone_clear": "Сбросить зону",
      "install_zone_empty": "Зоны не найдены",
      "install_zone_no_matching_cities": "Города не найдены",
      "install_zone_not_assigned": "Не назначена",
      "logists_filter": "Логисты",
      "no_install_zone": "Нет зоны",
      "no_installer": "Не выбран СЛС",
      "group_no_installer": "У сущностей группы не выбран СЛС",
      "group_no_installer_count": "В группе не выбран СЛС у {{count}} сущностей",
      "change_intention_hint": {
        "title": "Будут применены изменения",
        "entity_count": "Сущностей: {{count}}",
        "affected_count": "{{count}} сущ.",
        "old_value": "Было",
        "new_value": "Стало",
        "not_selected": "Не выбрано",
        "no_services": "Без услуг",
        "not_assigned": "Не назначен",
        "date_not_specified": "Дата не указана",
        "installer_deleted": "{{product}}: удалить СЛС {{installer}}",
        "fields": {
          "counterpartySubdivisionId": "Подразделение",
          "date": "Дата",
          "deliveryAddress": "Адрес",
          "installZoneId": "Зона установки",
          "installerId": "СЛС",
          "logistId": "Логист",
          "productInstallers": "Альтернативные СЛС",
          "products": "Услуги",
          "time": "Время"
        }
      },
      "logs": {
        "action": "Действие",
        "actor_filter": "Автор",
        "author": "Автор",
        "contract": "Договор",
        "counterparty_id": "Контрагент ID",
        "date": "Дата",
        "description": "Описание",
        "empty": "Логов по выбранным фильтрам нет",
        "entity": "Сущность",
        "event_filter": "Действие",
        "field": "Поле",
        "fields": {
          "counterpartySubdivisionId": "Подразделение",
          "date": "Дата",
          "deliveryAddress": "Адрес",
          "installZoneId": "Зона установки",
          "installerId": "СЛС",
          "logistId": "Логист",
          "products": "Услуги",
          "time": "Время"
        },
        "events": {
          "bulkApplied": "Массовое изменение",
          "changeIntentionApplied": "Намерение применено",
          "changeIntentionCanceled": "Намерение отменено",
          "changeIntentionCreated": "Намерение создано",
          "changeIntentionUpdated": "Намерение изменено",
          "entityAssigned": "Назначение",
          "productsUpdated": "Услуги",
          "reservationCreated": "Бронь создана",
          "reservationDateUpdated": "Дата брони изменена",
          "reservationDeleted": "Бронь удалена",
          "returnedToQueue": "Возврат"
        },
        "items_count": "{{count}} шт.",
        "load_more": "Показать еще",
        "new_value": "Стало",
        "not_selected": "Не выбрано",
        "old_value": "Было",
        "open": "История",
        "project_number": "Номер проекта",
        "refresh": "Обновить",
        "request": "Заявка",
        "reservation": "Бронь",
        "search": "Заявка, проект или договор",
        "system_actor": "Система",
        "title": "История изменений"
      },
      "reservation_summary_placeholder": "Сводка по брони пока недоступна",
      "reservation_summary_details": "Детали брони",
      "reservation_summary_people": "Люди",
      "return_to_queue": "Вернуть в распределение",
      "search": "Поиск",
      "select_all": "Выбрать все",
      "selected": "Выбрано: {{count}}",
      "selected_logists": "Логистов: {{count}}",
      "services": "Услуги",
      "time": "Время",
      "unassigned_logist": "Логист не выбран",
      "without_city": "Без города",
      "bulk_actions": {
        "actions": "Действия",
        "change_address": "Изменить адрес",
        "change_date": "Изменить дату",
        "change_status": "Изменить статус",
        "change_time": "Изменить время",
        "multiple_counterparties": "Несколько заказчиков",
        "no_subdivision": "Без подразделения",
        "return_to_queue_dialog_message": "Вернуть в распределение {{count}} выбранных заявок и броней?",
        "return_to_queue_dialog_title": "Подтвердите возврат",
        "status_changed": "Статус заявок изменён",
        "status_change_partial_message": "Доступно для изменения: {{eligibleCount}}. Исключено: {{rejectedCount}}.<br>{{rejectedDetails}}",
        "status_change_partial_title": "Не все заявки можно изменить",
        "status_change_apply_partial_title": "Статус изменён не у всех заявок",
        "status_change_unavailable": "Смена статуса недоступна",
        "show_all_services": "Показать все",
        "clear_services": "Очистить услуги",
        "close": "Закрыть"
      },
      "product_installers": {
        "title": "Альтернативный СЛС",
        "product": "Услуга",
        "select_product": "Выберите услугу",
        "pending_changes": "Есть изменения, ожидающие подтверждения",
        "assignments": "Назначения",
        "will_delete": "будет удалён",
        "pending": "ожидает подтверждения",
        "date_not_specified": "дата не указана",
        "edit": "Изменить",
        "restore": "Вернуть",
        "delete": "Удалить",
        "edit_assignment": "Изменить назначение",
        "add": "Добавить альтернативного СЛС",
        "specialist": "Специалист",
        "not_selected": "Не выбран",
        "scheduled_date": "Плановая дата",
        "cost": "Итоговая стоимость",
        "apply": "Применить",
        "cancel": "Отмена",
        "close": "Закрыть",
        "save": "Сохранить",
        "search": "Поиск по ФИО или городу",
        "nothing_found": "Ничего не найдено"
      },
      "realtime_update": {
        "body": "Коллега изменил данные в реестре.",
        "cancel": "Отмена",
        "heading": "Данные обновились",
        "refresh": "Обновить",
        "type": "Реестр логиста"
      },
      "realtime_sync": {
        "syncing": "Синхронизация…",
        "synchronized": "Данные синхронизированы",
        "failed": "Не удалось синхронизировать — повторить"
      },
      "detached_logist_city": "Город не прикреплён к логисту"
    }
  },
  "quality_statuses": {
    "0": "Не проверена",
    "1": "Заявки без ошибок",
    "2": "Заявки с ошибками",
    "3": "Заявки с критическими ошибками",
    "4": "Заявки с исправленными ошибками",
    "5": "Заявки с частично исправленными ошибками"
  },
  "request_product": {
    "claimed": "Заявлено:",
    "completed": "Выполнено",
    "not_completed": "Не выполнено",
    "service_product": "Услуга / товар:",
    "installed_devices": "Установленные устройства:"
  },
  "request_products": {
    "1": "Услуга выезда",
    "2": "X-Keeper INVIS DUOS",
    "3": "X-Keeper OBD II",
    "4": "X-Keeper Invis DUOS S",
    "5": "Установка оборудования",
    "6": "Приемка-передача ПЛ",
    "7": "Подписание",
    "8": "Осмотр ПЛ/Имущества/Бизнеса",
    "9": "Передача топливных карт",
    "10": "X-Keeper Invis DUOS 3D L",
    "11": "Подписание актов (неявка / отказ)",
    "12": "Маркировка",
    "13": "Приемка-передача оборудования",
    "14": "Осмотр с бустером",
    "15": "Подготовка легкового ТС",
    "16": "Подготовка грузового ТС/спец техники",
    "17": "Демонстрация ПЛ",
    "18": "Демонстрация ПЛ с бустером",
    "19": "Чехол защитный антивандальный",
    "20": "Магнит 20x3",
    "21": "X-Keeper ONLINE SLIM",
    "22": "X-Keeper Invis DUOS Container Tracker",
    "23": "Гарантийный выезд (М1)",
    "24": "Гарантийный выезд",
    "29": "Гарантийный выезд (М2)",
    "30": "Гарантийный выезд (М3)",
    "31": "Гарантийный выезд (М4)",
    "32": "Гарантийный выезд (М5)",
    "33": "Гарантийный выезд (последующие)",
    "34": "Приемка-передача ПЛ без ПТС/ПСМ",
    "35": "Установка мониторинга без блокировки ДВС",
    "36": "Установка мониторинга с блокировкой ДВС",
    "38": "X-Keeper ONLINE SPACE",
    "39": "Подарочный набор",
    "40": "Осмотр ТС, подписание ДКП и приёмка-передача ТС",
    "41": "Осмотр ТС, подписание ДКП и приёмка-передача ТС. Отмена, фиксация недостатков",
    "42": "Приёмка-передача ТС ФЛ",
    "43": "Приёмка-передача ТС ФЛ. Отмена, фиксация недостатков",
    "44": "Осмотр и Приёмка-передача ТС ЮЛ/ИП",
    "45": "Осмотр и Приёмка-передача ТС ЮЛ. Отмена, фиксация недостатков",
    "46": "Приёмка-передача ТС СТОК",
    "47": "Приёмка-передача ТС СТОК. Отмена, Расторжение ДКП",
    "48": "Осмотр ТС и подписание ДКП СТОК",
    "49": "Осмотр ТС и подписание ДКП",
    "50": "Осмотр ТС и подписание ДКП. Отмена, фиксация недостатков",
    "51": "Отмена, фиксация недостатков",
    "52": "Подготовка к изъятию",
    "53": "X-Keeper ONLINE SPACE PRO"
  },
  "request_statuses": {
    "1": "Новая",
    "3": "Выполнено",
    "6": "Запрос на редактирование",
    "7": "На редактировании",
    "8": "Проверка завершена",
    "9": "Заявка ждёт проверки",
    "10": "В работе",
    "11": "Выдано",
    "12": "Назначен специалист по установке",
    "13": "Ошибка в заявке",
    "14": "Отменена",
    "15": "Отклонена",
    "16": "Отклонена"
  },
  "request_ratings": {
    "3": "Отсутствует ПТС/ПСМ (в день выдачи)",
    "4": "Ожидание ЛП/Поставщика (Клиент задержался более чем на 1 час)",
    "5": "В заявке указаны не верные данные",
    "6": "Менеджеру от поставщика не было сообщено об установке маяков",
    "7": "Акт тех. ошибки (Опечатки, ошибки в Акте приема-передачи)",
    "11": "НЕ АКТУАЛЬНАЯ ОЦЕНКА, ПРОСЬБА НЕ ИСПОЛЬЗОВАТЬ Опечатки, ошибки в образце Счет-фактуры/УПД",
    "12": "НЕ АКТУАЛЬНАЯ ОЦЕНКА, ПРОСЬБА НЕ ИСПОЛЬЗОВАТЬ Опечатки, ошибки в образце Товарной накладной",
    "13": "Адрес (несоответствие адреса места отгрузки)",
    "14": "Не готово ТС (ПЛ не готов к отгрузке)",
    "15": "Допуск к ПЛ (отказ в допуске к ПЛ для маякования)",
    "16": "Ожидание Акта (отсутствие АПП к назначенному времени выдачи)",
    "17": "Ожидание Полиса (приезд на выдачу и страховка не готова)",
    "18": "Доверенность ДКП/ДЛ (отсутствие дов. на подписантов ДКП/ДЛ)",
    "19": "Акт неверный (не соответствия данных с Актом, когда ДКП верный)",
    "21": "Отсутствие ЛП/Поставщика (Клиент не приехал)",
    "22": "Нет ДКП/ДЛ (Нет договорной базы)",
    "23": "Лояльность Поставщика (Пост. не готов к диалогу по испр. ошибок)",
    "24": "$ риск  (Денежное вознаграждение от Поставщика/ЛП)",
    "25": "Замена ПЛ (данные ПТС/ПСМ не соответствуют заявке)",
    "26": "КМ взял на себя ответственность за исправление первички",
    "27": "КМ взял на себя ответственность за предоставление документов",
    "28": "В заявке неверные контакты ЛП/Поставщика/КМ",
    "29": "Нет ОБРАЗЦОВ ТТН/СФ",
    "30": "Ожидание исправления актов более 1 часа",
    "31": "Ожидание предоставления Поставщиком первички (более чем 1 час)",
    "32": "ЛП не предупрежден о передаче 2го комплекта ключей в ЛК",
    "33": "Ожидание исправления первички более 1 часа",
    "34": "Заявка проверена ОКК",
    "35": "Некорректный комментарий",
    "36": "Нет подтверждения актуального адреса выдачи",
    "38": "Не отправлено уведомление о смене статуса",
    "39": "Отсутствие комментария к заявке",
    "40": "Отсутствие оценки к заявке",
    "41": "Сканы документов ненадлежащего качества",
    "42": "Фото ПЛ ненадлежащего качества",
    "43": "Фото мест установки ненадлежащего качества",
    "44": "Ошибки в АПП",
    "45": "Ошибки в первичной документации",
    "47": "Некорректная установка маяка",
    "48": "Отсутствие фото ПЛ",
    "49": "Отсутствие фото мест установки",
    "50": "Несвоевременное закрытие заявки",
    "51": "Несвоевременная смена статуса",
    "53": "Опоздание на выдачу СЛС",
    "54": "Отсутствие скана документа",
    "55": "Отсутствие отметки 'экземпляр ЛК'",
    "56": "Поставщик уведомил ЛП об установке маяка/ов",
    "57": "Образцы ТН и СФ не подгружены в заявку",
    "58": "Сканы документов неправильного формата (JPEG, BMP и тд)",
    "59": "Ожидание ПТС (приезд на выдачу и ПТС отсутствует, привезли позже)",
    "60": "Некорректная оценка к заявке",
    "61": "Несвоевременное добавление комментария к заявке",
    "62": "Маякование в присутствии 3-их лиц",
    "63": "Отсутствие фото сотрудника СЛС",
    "65": "КМ уведомил ЛП об установке маяка/ов",
    "66": "Смена подписанта в АПП",
    "67": "ПП более 60 минут",
    "68": "Отсутствие GPRS и GSM сетей на месте маякования",
    "69": "Ошибки в документах",
    "70": "Маякование на территории ЛП",
    "71": "Долгое ожидание перевода собственника по ЭПТС (более 30 минут)",
    "72": "Долгий осмотр и приемка ПЛ ЛП (более 30 минут)",
    "73": "Длительное ожидание ответа по согласованию с заказчиком (более 30 минут)",
    "75": "Несоответствие внешнего вида СЛС",
    "76": "Первичка проверена РПД",
    "77": "заявка создана менее чем за 12 часов до заявленного времени",
    "78": "заявка создана менее чем за 24 часа до заявленного времени",
    "79": "заявка создана менее чем за 6 часов до заявленного времени",
    "80": "заявка создана более чем за 24 часа до заявленного времени",
    "81": "Итоговый вариант в образцах",
    "83": "Маяк не работает",
    "84": "1 доступное место",
    "85": "МАЯКИ ВКЛЮЧЕНЫ ДО УСТАНОВКИ",
    "86": "БЕЗ УСТАНОВКИ/НЕТ ДОСТУПНЫХ МЕСТ",
    "87": "ПРИМЕНЕНА МАРКИРОВКА ПЛ",
    "88": "УСЛОВИЯ НЕПРИГОДНЫ ДЛЯ МАРКИРОВКИ",
    "89": "УСТАНОВКА ДО ПП",
    "90": "ПРОВЕРКА ВЫХОДА НА СВЯЗЬ В ДЕНЬ ПП",
    "92": "СТОК",
    "94": "Маркировка при ЛП",
    "95": "Маякование в присутствии представителя поставщика",
    "96": "Маякование в присутствии представителя поставщика",
    "97": "Нет информации по П/П (не для СЛС)",
    "105": "Установка номерных рамок (обычные)",
    "106": "Установка номерных рамок (премиум)",
    "107": "Невозможность установки номерных рамок",
    "117": "Некорректное оформление фото мест маркировки",
    "118": "Отсутствует Акт Маркировки",
    "119": "Некорректное заполнение Акта маркировки",
    "121": "Количество точек маркировки не соответствует количеству услуг маркировки",
    "156": "Документ более 1 листа загружен несколькими файлами.",
    "157": "Не прописано основание ЛП в АПП",
    "159": "Некорректные фото ключей",
    "160": "Нет фото комплекта ключей ЛК",
    "161": "Нет фото жала ключей",
    "162": "Печать СЛС в первичке",
    "163": "Печать СЛС в АПП (АМ)",
    "164": "Нет подписи СЛС в ТН",
    "165": "Нет подписи СЛС в УПД",
    "166": "Нет даты приемки в первичке",
    "167": "Фото СЛС не в полный рост",
    "168": "Нет фото ПЛ (Маркировка колес)",
    "169": "Нет фото ПЛ (Номер кабины)",
    "170": "Нет фото ПЛ (Номер шасси)",
    "171": "Нет фото ПЛ (Запаска)",
    "172": "Нет фото ПЛ (Общий вид)",
    "173": "Нет фото ПЛ (Салон)",
    "174": "Нет фото ПЛ (Номер VIN)",
    "175": "Нет фото ПЛ (Пробег)",
    "177": "Не четкая печать СЛС",
    "178": "Не четкий штамп СЛС",
    "179": "Нет должности поставщика в первичке",
    "180": "Нет должности СЛС в первичке",
    "181": "Печать СБЛ в АПП (Не регистрируемый ПЛ)",
    "182": "Заявка закрыта с несоответствующим набором услуг",
    "183": "Отсутствует пробег в АПП",
    "185": "Нет оценки 'ПРИМЕНЕНА МАРКИРОВКА'",
    "186": "ФИО подписанта прописано не полностью (Смена подписанта)",
    "187": "Не указано 1 или 2 маяк/описания места установки",
    "188": "Смена подписанта, нет оценки",
    "189": "Нет сканов ДС(ВТБ)",
    "191": "Нет фото установки рамок",
    "199": "Отсутствуют подписи в АПП",
    "201": "Нет фото ПЛ (Номер двигателя)",
    "202": "Отсутствует комментарий о невозможности сверить номер двигателя",
    "203": "Нет комментария/оценки о невозможности установки рамок",
    "204": "СВЯЗАТЬСЯ С ОКК!",
    "205": "Не корректно заверенная доверенность / нет 'Копия верна' / подписи ФИО заверившего / печати",
    "208": "Использование фото одного и того же ПЛ",
    "210": "Отсутствует ВИЗА",
    "218": "Нет скана/фото паспорта (РАЛ)",
    "220": "Не загружена доверенность ЛП/поставщика",
    "221": "Отсутствует скан ПТС/ЭПТС/ПСМ/ЭПСМ",
    "222": "Документы/фото подгружены в не корректную категорию",
    "225": "Нечеткая печать ЛП/поставщика",
    "238": "Нечеткое фото паспорта",
    "242": "Нет оценки, какие установлены рамки",
    "244": "отгрузка без согласования с заказчиком",
    "245": "Фото СЛС не на фоне ПЛ",
    "246": "Получен не полный комплект ключей",
    "247": "Фото паспорта с отсутствующем СОПД",
    "249": "Нет фото паспорта ЛП",
    "252": "Нет фото расположения VIN/Заводского номера",
    "253": "Отсутствует ВИЗА",
    "254": "Некорректные места маркировки",
    "255": "ФИО в ВИЗЕ прописано не полностью",
    "257": "Фотоотчет без использования приложения",
    "258": "Фото без GPS координат/Адреса",
    "260": "Нет фото маркировочного баллона",
    "261": "В стр33242342",
    "262": "Фото СОР не на фоне VIN",
    "265": "Несоответствие адреса отгрузки",
    "266": "Не корректное оформление мест маякования",
    "267": "Поставщик не уведомлён о необходимости видеофиксации ключей",
    "272": "Невозможность фотофиксации маяка в месте установки",
    "276": "Установка в зоне действия РЭБ",
    "277": "Маяк не активировался, направлена команда для активации"
  },
  "requests_list": {
    "all_requests": "Все заявки",
    "all_requests_completed": "Все заявки выполнены!",
    "columns": {
      "requestNumber": "Заявка",
      "releaseTime": "Когда(время)",
      "releaseDate": "Когда(дата)",
      "releaseDatePeriod": "Когда(время и дата)",
      "contract": "Договор",
      "car": "ПЛ",
      "carPlantNumber": "Госномер",
      "vin": "VIN номер",
      "subjName": "ЛП",
      "deliveryAddress": "Адрес",
      "counterPartyName": "Заказчик",
      "products": "Товары и услуги",
      "installerShort": "СЛС",
      "statusId": "Статус",
      "deliveryName": "Салон",
      "createdAt": "Дата создания",
      "updatedAt": "Дата обновления",
      "qualityControlStatus": "Статус ОКК",
      "docs": "Е-ПТС/ФОТО ПЛ/АПП к ДЛ/АПП к ДКП",
      "projectNumber": "Номер проекта"
    },
    "columns_settings_title": "Настройки колонок",
    "completed": "Выполнено",
    "edit_requests": "Редактировать заявки",
    "given": "Выдано",
    "group_actions": "Групповые действия",
    "my_requests": "Заявки для меня",
    "no_requests_for_today": "На сегодня нет заявок!",
    "no_requests_in_work": "Заявок в работе нет",
    "nothing_found_matching": "По вашему запросу ничего не найдено",
    "of": "из",
    "requests_in_work": "Заявки в работе",
    "requests_table_header": "Таблица заявок",
    "rows_settings": {
      "edit_button": "Редактировать вид",
      "rowBgColorStatus": "Цвет строк по статусу"
    },
    "rows_settings_title": "Настройки строк",
    "selected_requests": "Выбрано заявок:",
    "selected_requests_in_work": "Выбрано заявок в работе:",
    "show_all": "Показать все",
    "today": "Сегодня",
    "found": "Найдено",
    "reset": "Сбросить"
  },
  "requests_list_item": {
    "undefined_car_plant_number": "Без госномера",
    "no_vin": "Без VIN",
    "not_assigned": "Не назначен",
    "request_not_completed": "Заявка не выполнена",
    "request_on_edit": "Запрос на редакт...",
    "specialist_assigned": "Назначен специалист",
    "undefined_address": "Без адреса",
    "undefined_contract": "Неизв. договор",
    "undefined_date": "Неизв. дата",
    "undefined_lease_product": "Неизвестный ПЛ",
    "undefined_project_number": "Неизвестный номер проекта",
    "undefined_lease_recipient": "Неизвестный ЛП",
    "undefined_delivery_name": "Неизвестный поставщик",
    "undefined_counterparty_name": "Неизвестный заказчик",
    "delivery_address_different_from_actual": "Адрес выдачи отличается от актуального",
    "delivery_address_confirmed": "Адрес выдачи подтвержден",
    "doc_not_found": "Документ не найден",
    "guest_view": "Гостевой просмотр",
    "generate_guest_link": "Сгенерировать гостевую ссылку",
    "guest_link_copied": "Гостевая ссылка скопирована",
    "guest_link_failed": "Не удалось создать гостевую ссылку",
    "revoke_guest_links": "Отозвать все гостевые ссылки",
    "revoke_guest_links_confirm_title": "Отозвать гостевые ссылки",
    "revoke_guest_links_confirm_text": "Все ранее выпущенные гостевые ссылки для этой заявки перестанут работать. Продолжить?",
    "revoke_guest_links_success": "Гостевые ссылки отозваны",
    "revoke_guest_links_failed": "Не удалось отозвать гостевые ссылки",
    "epts_hint": "Скачать Е-ПТС",
    "lp_photo_hint": "Скачать Фото ПЛ",
    "obrz_app_k_dl_hint": "Скачать АПП к ДЛ",
    "obrz_app_k_dkp_hint": "Скачать АПП к ДКП",
    "epts_not_found": "Е-ПТС не найден",
    "lp_photo_not_found": "Фото ПЛ не найдено",
    "obrz_app_k_dl_not_found": "АПП к ДЛ не найден",
    "obrz_app_k_dkp_not_found": "АПП к ДКП не найден",
    "create_temporary_access": "Создать временный доступ"
  },
  "temporary_access_dialog": {
    "title": "Создать временный доступ",
    "password_once_warning": "Пароль отображается только один раз. Сохраните его.",
    "email_label": "Email",
    "password_label": "Пароль",
    "done": "Готово",
    "roles_profile_label": "Профиль ролей",
    "profile_placeholder": "Выберите профиль",
    "profile_fallback_prefix": "Профиль #",
    "expires_at_label": "Дата окончания доступа",
    "cancel": "Отмена",
    "submit": "Создать",
    "error_load_profiles": "Не удалось загрузить профили ролей",
    "error_create": "Не удалось создать временный доступ",
    "error_fill_all": "Заполните все поля"
  },
  "alternative_requests_widget": {
    "title": "Альтернативные заявки",
    "load_failed": "Не удалось загрузить альтернативные заявки. Повторите попытку."
  },
  "request_form": {
    "actual_address": {
      "actual_address": "Актуальный адрес",
      "check_on_map": "Проверить на карте",
      "checked": "Проверен",
      "confirm": "Подтвердить",
      "differs": "(отличается от заявленного)",
      "no_rights_to_change": "У вас отсутствуют права на изменение адреса",
      "validation_required": "Нуждается в проверке",
      "reset": "Сбросить",
      "address_placeholder": "Введите актуальный адрес выдачи"
    },
    "change_status_button": {
      "change_status_title": "Изменить статус"
    },
    "restricted_view": {
      "guest_view": "Быстрый просмотр",
      "request": "Заявка",
      "logout": "Выйти",
      "common_info": "Основная информация",
      "project_number": "№ проекта",
      "contract": "Договор",
      "release": "Дата выдачи",
      "counterparty": "Заказчик",
      "vehicle": "Автомобиль",
      "car": "Модель",
      "vin": "VIN",
      "car_type": "Тип ТС",
      "car_year": "Год выпуска",
      "car_plant_number": "Гос. номер",
      "products": "Продукты и услуги",
      "no_products": "Продукты и услуги не указаны",
      "devices": "Оборудование",
      "device_model": "Модель устройства:",
      "device_sim_1": "СИМ 1",
      "device_sim_2": "СИМ 2",
      "device_install_date": "Дата установки",
      "device_mount_type": "Способ крепления",
      "device_onboard_voltage": "Бортовое напряжение",
      "device_cutoff_switch": "Выключатель массы",
      "device_has_protect_case": "Защитный кейс",
      "no_devices": "Оборудование не указано",
      "delivery": "Место выдачи",
      "files": "Файлы заказчика",
      "no_files": "Файлы отсутствуют",
      "contact": "Контакт",
      "comments": "Комментарии",
      "new_comment_placeholder": "Напишите комментарий",
      "send_comment": "Отправить комментарий",
      "no_comments": "Комментариев пока нет",
      "invalid_link_title": "Ссылка недействительна",
      "invalid_link_description": "Срок доступа истёк или ссылка была отозвана.",
      "invalid_link_action": "Запросите новую ссылку у отправителя.",
      "load_error_title": "Не удалось загрузить заявку",
      "load_error_description": "Попробуйте открыть ссылку позже или запросите новую ссылку у отправителя.",
      "load_error_action": "Если ошибка повторяется, свяжитесь с отправителем ссылки."
    },
    "common": {
      "additional_data": {
        "title": "Дополнительная информация",
        "shipment_docs_address": "Адрес отправки оригиналов документов",
        "timezone": "Часовой пояс"
      },
      "car": {
        "title": "Автомобиль",
        "car_brand_id": "Марка",
        "car_model": "Модель",
        "car_type": "Тип ТС",
        "VIN": "VIN",
        "car_plant_number": "Заводской номер",
        "car_year": "Год выпуска",
        "manufacturer_country": "Страна изготовитель"
      },
      "contract": {
        "title": "Договор лизинга",
        "contract_number": "Номер",
        "contract_date": "Дата",
        "select_date_placeholder": "Выберите",
        "contract_planned_end_date": "Плановая дата окончания договора лизинга",
        "select_planned_end_date_placeholder": "Выберите",
        "contract_early_end_date": "Досрочная дата окончания договора лизинга",
        "select_early_end_date_placeholder": "Выберите"
      },
      "lessee": {
        "title": "Лизингополучатель",
        "lessee_name": "Наименование",
        "lessee_inn": "ИНН",
        "lessee_fullname": "ФИО",
        "lessee_phone_number": "Телефон"
      },
      "logists": {
        "title": "Логисты заказчика",
        "logist_fullname": "ФИО логиста заказчика",
        "logist_phone_number": "Телефон логиста заказчика",
        "leasing_product": "Лизинговый продукт",
        "extended_program": "Расширение программы"
      },
      "main": {
        "title": "Основные",
        "project_number": "№ проекта",
        "counterparty_owner": "Заказчик",
        "error_counterparty_owner_not_defined": "неизв. (ошибка)",
        "contractor_counterparty": "Исполнитель",
        "contractor_counterparty_subdivision": "Подразделение",
        "install_zone": "Зона установки",
        "install_price": "Цена установки",
        "installer": "Специалист по сопровождению"
      },
      "managers": {
        "title": "Менеджеры",
        "support_manager_fullname": "ФИО менеджера сопровождения",
        "support_manager_phone_number": "Телефон менеджера сопровождения",
        "client_manager_fullname": "ФИО менеджера клиента",
        "client_manager_phone_number": "Телефон менеджера клиента",
        "client_manager_email": "Email менеджера клиента"
      },
      "supplier": {
        "title": "Поставщик",
        "delivery_name": "Название салона выдачи ПЛ",
        "delivery_address": "Адрес салона выдачи ПЛ",
        "delivery_person_name": "Представитель поставщика",
        "delivery_person_phone_number": "Телефон контактного лица в салоне",
        "delivery_person_phone_email": "Email контактного лица в салоне",
        "release_title": "Выдача",
        "actual_release_date": "Планируемая дата выдачи",
        "actual_release_date_differs": "(отличается от фактической)",
        "release_date_placeholder": "Выберите",
        "release_time": "Планируемое время выдачи",
        "actual_release_date_block": {
          "actual_date_differs": "Дата выдачи отличается?",
          "actual_release_date": "Фактическая дата выдачи",
          "actual_release_date_placeholder": "Выберите",
          "error_required": "Обязательно",
          "button_save": "Сохранить",
          "button_change": "Изменить",
          "dialog_change_release_date": "Вы уверены, что хотите изменить дату выдачи",
          "dialog_change_release_date_yes": "Да, сохранить",
          "dialog_change_release_date_no": "Отмена",
          "success_change_release_date": "Фактическая дата выдачи сохранена",
          "dialog_reset_release_date": "Вы действительно хотите сбросить фактическую дату выдачи?",
          "dialog_reset_release_date_yes": "Да, сбросить",
          "dialog_reset_release_date_no": "Отмена",
          "success_reset_release_date": "Фактическая дата выдачи сброшена"
        }
      }
    },
    "comments": {
      "no_comments": "Список комментариев пуст",
      "new_comment_placeholder": "Новый комментарий",
      "send_button": "Отправить",
      "dialog_delete_comment": "Вы уверены, что хотите удалить комментарий?",
      "dialog_delete_selected_comments": "Вы уверены, что хотите удалить выбранные комментарии?",
      "dialog_delete_comment_title": "Удаление комментария",
      "dialog_delete_selected_comments_title": "Удаление выбранных комментариев",
      "dialog_delete_comment_yes": "Да",
      "dialog_delete_comment_no": "Нет"
    },
    "deal_details": {
      "no_deal_details": "Детали сделки не заполнены",
      "installer_arrival_time_title": "Время приезда",
      "your_arrival_time": "Ваше время приезда",
      "installer_arrival_time": "Время приезда СЛС",
      "error_required": "Необходимо указать значение",
      "lessees_arrival_time": "Время приезда ЛП",
      "deal_time_title": "Время сделок",
      "deal_start_time": "Начало сделки",
      "deal_end_time": "Конец сделки",
      "deal_duration": "Длительность",
      "not_defined_value": "Не указано",
      "installing_place_title": "Место маякования",
      "installing_place_outdoor": "На открытой площадке",
      "installing_place_indoor": "В помещении",
      "additionally_title": "Дополнительно",
      "deal_was_done": "Сделка состоялась",
      "additionally_third_parties": "Присутствовали третьи лица",
      "without_third_parties": "Без посторонних",
      "additionally_documents_given": "Документы получены",
      "additionally_keys_given": "Ключи получены",
      "additionally_nothing_given": "Документы или ключи не получены",
      "primary_documentation": "Первичная документация",
      "primary_documentation_edo": "Первичная документация по ЭДО",
      "primary_documentation_paper": "Первичная документация на бумаге",
      "primary_documentation_absent": "Первичная документация отсутствовала",
      "primary_documentation_not_filled": "Не заполнено",
      "notes_title": "Примечания",
      "notes_max_chars_error": "Максимальная длина 10 000 символов",
      "boolean_field_yes": "Да",
      "boolean_field_no": "Нет",
      "devices_demount_title": "Демонтаж устройств",
      "demount_exist": "Был ли демонтаж устройств?",
      "demount_count": "Количество демонтированных устройств",
      "demount_placeholder": "от 1 до 5 устройств",
      "demount_count_error": "Количество демонтированных устройств должно быть от 1 до 5",
      "error_max_length": "Максимальная длина {{maxLength}} символов",
      "button_save": "Сохранить",
      "button_close": "Закрыть"
    },
    "devices": {
      "add_device": {
        "add_button": "Добавить устройство",
        "sim_1": "СИМ 1",
        "sim_2": "СИМ 2",
        "mount_type": "Способ крепления",
        "mount_type_placeholder": "Выберите способ крепления",
        "onboard_voltage": "Бортовое напряжение",
        "onboard_voltage_placeholder": "Выберите Бортовое напряжение",
        "cutoff_switch": "Выключатель массы",
        "cutoff_switch_placeholder": "Выберите выключатель массы",
        "device_install_date_title": "Когда установлен маяк:",
        "device_install_date_placeholder": "Выберите",
        "device_install_date_cannot_be_changed": "Дату нельзя будет изменить",
        "cancel_button": "Отмена",
        "save_button": "Добавить",
        "dialog_add_device": "Вы действительно хотите добавить устройство",
        "dialog_add_device_yes": "Да, добавить",
        "dialog_add_device_no": "Отмена",
        "dialog_confirm_release_date": "Вы указали, что устройство было установлено {{deviceInstallDate}}, но планируемая дата выдачи {{releaseDate}}. Вы уверены, что хотите продолжить?",
        "dialog_confirm_release_date_yes": "Да",
        "dialog_confirm_release_date_no": "Отмена",
        "error_getting_device_model_id": "Не удалось получить модель устройства. Пожалуйста, попробуйте позже.",
        "additional_settings_title": "Дополнительные данные устройства",
        "additional_settings_modal_submit_button": "Подтвердить"
      },
      "device": {
        "tooltip_device_in_protective_case": "Устройство в защитном кейсе",
        "installed": "установлено",
        "sim_1": "СИМ 1",
        "sim_2": "СИМ 2",
        "no_sim_2": "Отсутствует",
        "profile": "Профиль",
        "profile_undefined": "Неизвестно",
        "events": "Извещений",
        "events_undefined": "Неизвестно",
        "last_device_data": "Последние данные",
        "last_device_data_undefined": "Неизвестно",
        "days_ago": "дн. назад",
        "today_tag": "сегодня",
        "coordinates": "Координаты",
        "before": "за",
        "days_before_last_data": "дн. до последних данных",
        "coordinates_undefined": "Неизвестно",
        "address": "Адрес",
        "address_undefined": "Неизвестно",
        "device_hash": "Device Hash",
        "mount_type": "Способ крепления",
        "onboard_voltage": "Бортовое напряжение",
        "cutoff_switch": "Выключатель массы",
        "install_quality": {
          "install_quality": "Качество установки",
          "check_in_progress": "Проверяется",
          "checked_at": "Проверено",
          "bad": "Не пройдено",
          "gps_good": "Успешно (GPS)",
          "gsm_or_wifi_good": "Успешно (GSM/WiFi)",
          "bad_short": "Ошибка",
          "gps_good_short": "GPS",
          "gsm_or_wifi_good_short": "GSM/WiFi",
          "by_browser_coords": "По координатам с устройства СЛС",
          "by_delivery_address": "По заявленному адресу салона выдачи",
          "by_actual_delivery_address": "По актуальному адресу выдачи",
          "address_unavailable": "Адрес недоступен",
          "timed_out": "Время истекло",
          "never_checked": "Проверка не проводилась",
          "never_checked_short": "Не проверено",
          "check_now": "Проверить"
        },
        "tamper": {
          "title": "Датчик монтажа",
          "loading": "Загрузка...",
          "error": "Ошибка",
          "no_data": "Нет данных",
          "mounted": "Прижат",
          "not_mounted": "Не прижат",
          "not_mounted_unknown": "Не прижат?"
        },
        "location_updater": {
          "set_button": "Указать"
        },
        "remover": {
          "dialog_remove_device": "Вы действительно хотите удалить устройство",
          "dialog_remove_device_yes": "Да, удалить",
          "dialog_remove_device_no": "Отмена"
        }
      },
      "no_devices": "Список устройств пуст",
      "protective_case": {
        "there_is_case": "Есть антивандальный чехол",
        "case_number": "Номер чехла",
        "error_required": "Обязательно"
      },
      "update_device": {
        "sim_1": "СИМ 1",
        "sim_2": "СИМ 2",
        "button_cancel": "Отмена",
        "button_save": "Сохранить"
      },
      "mount_options": {
        "magnets": "Магниты",
        "double_sided_tape": "Двусторонний скотч",
        "ties": "Стяжка",
        "metal_mount": "Металлический крепеж"
      },
      "cutoff_switch_options": {
        "yes": "Есть",
        "no": "Нет"
      }
    },
    "files": {
      "files_modal_title_from_customer": "Файлы от заказчика",
      "files_modal_title_from_client": "Файлы от исполнителя",
      "single_doc_file_cats_empty_message": "Категории с документами отсутствуют",
      "media_or_mixed_file_cats_empty_message": "Категории с медиа или смешанным контентом отсутствуют",
      "hint_delete_all_cat_files": "Удалить все файлы в категории",
      "dialog_delete_all_cat_files": "Вы действительно хотите удалить все файлы из этой категории?",
      "success_deleting_all_cat_files": "Файлы категории успешно удалены",
      "error_deleting_all_cat_files": "Ошибка удаления файлов категории",
      "important": "Важные",
      "photos": "Фотографии",
      "scans": "Сканы",
      "other": "Другое",
      "expand_for_customer_files": "Показать все",
      "collapse_for_customer_files": "Свернуть",
      "hint_request_to_delete": "Сделать запрос на удаление файла ",
      "hint_preview_image": "Предпросмотр изображения ",
      "hint_download_file": "Скачать файл",
      "hint_delete_file": "Удалить файл ",
      "hint_cancel_request_to_delete": "Отменить заявку на удаления файла ",
      "error_uploading_file": "Ошибка загрузки файла",
      "success_uploading_file": "Файл успешно загружен",
      "success_uploading_all_files": "Все файлы успешно загружены",
      "error_saving_file": "Ошибка сохранения файла",
      "dialog_delete_file": "Вы действительно хотите удалить файл ",
      "dialog_delete_file_title": "Удаление файла",
      "success_deleting_file": "Файл успешно удален",
      "error_deleting_file": "Ошибка удаления файла",
      "dialog_request_to_cancel_delete_title": "Запрос на отмену удаления файла",
      "dialog_request_to_cancel_delete_msg": "Вы действительно хотите отменить заявку на удаление файла",
      "dialog_request_to_delete_title": "Запрос на удаление файла",
      "dialog_request_to_delete_msg_1": "Вы действительно хотите создать заявку на удаление файла",
      "dialog_request_to_delete_msg_2": "Будет создан запрос на удаление файла. После одобрение администратором файл будет удален.",
      "success_request_to_cancel_delete": "Заявка на отмену удаления файла успешно создана",
      "success_request_to_delete": "Заявка на удаление файла успешно создана",
      "error_request_to_cancel_delete": "Ошибка создания запроса на отмену удаления файла",
      "error_request_to_delete": "Ошибка создания запроса на удаление файла",
      "vin_copied": "VIN скопирован в буфер обмена",
      "error_copied_vin": "Ошибка копирования VIN в буфер обмена",
      "download": {
        "tooltip": "Подробнее о том, какие категории будут скачаны",
        "request_docs_title": "Заявка",
        "download_docs_title": "Скачать документы",
        "generate_docs_title": "Генерация документов",
        "groups_title": "Группы категорий",
        "no_permission": "У вас нет доступа",
        "checklist_not_found": "Чек-лист не был загружен!",
        "generated_for": "Сгенерированные для ",
        "send_by_email": {
          "title": "Отчёт на Email",
          "email_placeholder": "Введите email",
          "send_button": "Отправить",
          "no_files_selected": "Выберите файлы для отправки!",
          "error_sending_files": "Невозможно отправить файлы заявки!",
          "success_sending_files": "Файлы отправлены на почту "
        },
        "file_links_names": {
          "open_pdf": "Открыть PDF",
          "download_pdf": "Скачать PDF",
          "tracker_form": "Анкета трекера",
          "checklist": "Скачать чек-лист",
          "act_no_lessee": "Скачать акт о неявке ЛП",
          "act_lessee_deny": "Скачать акт отказа",
          "act_no_release": "Скачать акт о несостоявшейся отгрузке",
          "act_car_review": "Скачать акт осмотра",
          "all_request_files": "Все файлы заявки",
          "created_with_api": "Скачать ",
          "generate_all_acts": "Сгенерировать все"
        }
      }
    },
    "goods": {
      "devices_mismatch": "Устройств в заявке: {{devicesAmountInRequest}}. Заявлено:{{ deviceProductsAmountInRequest}}",
      "empty_list": "Список товаров/услуг пуст",
      "complete_all": "Выполнить все",
      "errors_after_checking": "Имеются следующие ошибки: ",
      "success_after_checking": "Все поля заполнены",
      "hint_closed_forcingly": "Товар был выполнен принудительно!",
      "hint_completed_successfully": "Товар был выполнен!",
      "button_complete": "Выполнить",
      "closed_forcingly_reason": "Выполнено принудительно по причине:",
      "failed_attempt_to_close_reason": "Неудачная попытка выполнения по причине:",
      "not_all_conditions_are_met": "«Выполнены не все условия»",
      "devices": "Устройства:",
      "install_devices": "Установить устройства:",
      "pieces": "шт.",
      "write_comment": "Написать комментарий",
      "fill_deal_details": "Заполнить детали сделки",
      "fill_fields": "Заполнить поля:",
      "upload_files": "Загрузить файлы:",
      "additionally": "Дополнительно:",
      "button_cancel_forcibly_completion": "Подтвердить устранение причин",
      "button_cancel_completion": "Отменить выполнение",
      "preset_applied": "Применен пресет:",
      "forcibly_modal": {
        "button_complete_forcibly": "Выполнить принудительно",
        "button_complete_forcibly_cancel": "Отменить",
        "reason_step_header": "Укажите причину",
        "reason_step_placeholder": "Сообщение",
        "reason_step_error_required": "Обязательно",
        "button_complete_forcibly_reason_cancel": "Отменить",
        "button_complete_forcibly_reason_confirm": "Подтвердить"
      }
    },
    "complete_forcingly_modal": {
      "failed_to_close_forcibly": "Не удалось принудительно закрыть товар/услугу"
    },
    "loading": "Загрузка...",
    "obd": {
      "obd_status_title": "OBD Разъём",
      "obd_status_select_placeholder": "Выберите вариант",
      "obd_success_read_select_placeholder": "Выберите вариант",
      "obd_reading_data_result_label": "Результат чтения данных",
      "obd_comment_label": "Комментарий",
      "required_error": "Обязательно",
      "save": "Сохранить",
      "cancel": "Отменить",
      "dialog_update_obd_data": "Вы уверены что хотите сохранить данные OBD?",
      "dialog_update_obd_data_yes": "Да",
      "dialog_update_obd_data_no": "Нет",
      "success_updating_OBD_data": "Данные OBD успешно обновлены"
    },
    "inspection": {
      "inspection_title": "Осмотр",
      "inspection_status_null": "Нет данных",
      "inspection_status_true": "Положительный",
      "inspection_status_false": "Отрицательный",
      "button_submit": "Сохранить",
      "button_cancel": "Отмена",
      "dialog_update_inspection_status": "Вы уверены что хотите сохранить статус осмотра?",
      "dialog_update_inspection_status_yes": "Да",
      "dialog_update_inspection_status_no": "Нет",
      "success_updating_inspection_status": "Статус осмотра успешно обновлены",
      "error_updating_inspection_status": "Случилась ошибка при обновлении статуса осмотра",
      "inspection_status_not_changed": "Изначальный статус осмотра не отличается от нового"
    },
    "qc": {
      "qc_title": "Оценки контроля качества",
      "qc_modal_title": "Контроль качества",
      "qc_status_not_completed": "Заявка не завершена",
      "qc_status_no_errors": "Заявка без ошибок",
      "qc_status_some_errors": "Имеются ошибки",
      "qc_status_critical_errors": "Имеются критические ошибки",
      "qc_status_all_solved": "Все проблемы решены",
      "qc_status_partially_solved": "Ошибки исправлены частично",
      "qc_status_not_checked": "Заявка не проверена",
      "error_updating_rating": "Случилась ошибка при обновлении рейтинга",
      "success_updating_rating_comment": "Комментарий сохранен!",
      "problem_solved": "Проблема решена!",
      "comment": "Комментарий",
      "no_comment": "Нет комментария!",
      "qc_comment": "Комментарий отдела контроля качества",
      "installer_comment": "Комментарий СЛС",
      "created": "Создано",
      "enter_comment_placeholder": "Введите комментарий"
    },
    "ratings": {
      "error_updating_rating": "Случилась ошибка при обновлении рейтинга",
      "success_updating_rating": "Оценки проставлены! Перезагружаем изменённые заявки",
      "inside_deal_details_title": "Оценка",
      "search": "Поиск",
      "ratings_not_found": "Оценки не найдены",
      "collapse": "Свернуть",
      "expand": "Показать все",
      "no_ratings": "Оценки отсутствуют"
    },
    "tabs": {
      "summary": "Сводка",
      "status": "Статус",
      "deal_details": "Детали сделки",
      "address": "Адрес",
      "common": "Общее",
      "ratings": "Оценки",
      "comments": "Комментарии",
      "goods": "Товары и услуги",
      "devices": "Устройства",
      "obd": "OBD",
      "inspection": "Осмотр",
      "quality_control": "ОКК",
      "files": "Файлы",
      "files_installer": "От исполнителя",
      "files_client": "От заказчика",
      "files_download": "Скачать",
      "workflows": "Регламенты"
    },
    "summary": {
      "common_info": "Общие данные",
      "request": "Заявка",
      "request_number": "Номер заявки",
      "request_project": "Номер проекта",
      "request_contract": "Договор",
      "created": "Создана",
      "product": "Объект",
      "deal_details": "Детали сделки",
      "additionally": "Дополнительно",
      "history": "История",
      "delivery_person": "Представитель поставщика",
      "subject_person": "Лизингополучатель",
      "installer": "Исполнитель",
      "counterparty": "Заказчик",
      "lessee_inn": "ИНН",
      "car_category": "Тип ТС",
      "car_year": "Год выпуска",
      "manufacturerCountry": "Страна изготовитель",
      "products_and_services": "Товары и услуги",
      "enter_device_number": "Введите номер устройства",
      "files": "Файлы",
      "devices": "Устройства",
      "collapse": "Свернуть",
      "expand_all": "Показать все",
      "comments": "Комментарии",
      "anonymous": "Аноним",
      "contract_not_specified": "Договор лизинга не указан",
      "request_project_not_specified": "Номер проекта не указан",
      "subject_person_fullname_not_specified": "ФИО не указано",
      "subject_person_phone_not_specified": "Телефон не указан",
      "subject_name_not_specified": "Наименование не указано",
      "request_car_not_specified": "Предмет лизинга не указан",
      "request_car_type_not_specified": "Тип ТС не указан",
      "delivery_name_not_specified": "Название салона выдачи ПЛ не указано",
      "delivery_address_not_specified": "Адрес салона выдачи ПЛ не указан",
      "delivery_person_name_not_specified": "Представитель поставщика не указан",
      "delivery_person_phone_not_specified": "Телефон контактного лица в салоне не указан",
      "VIN_not_specified": "VIN не указан",
      "checklist_hint": "Скачать чек-лист",
      "installer_assignment": {
        "title": "Назначение исполнителя",
        "edit": "Изменить",
        "contractor": "Компания исполнитель",
        "subdivision": "Подразделение",
        "zone": "Зона установки",
        "installer": "Специалист по сопровождению",
        "clear": "Снять СЛС"
      },
      "release_city": "Город выдачи",
      "release_city_none": "Внимание! Не удалось определить город выдачи автоматически. Установите город вручную.",
      "release_city_manually": "Установлено/подтверждено вручную - не будет изменяться автоматически.",
      "release_city_auto": "Установлено автоматически - будет переопределено при изменении адреса.",
      "release_city_confirm": "Подтвердить",
      "release_city_change": "Изменить",
      "release_city_success": "Город выдачи успешно установлен",
      "release_city_error": "Ошибка установки города выдачи"
    },
    "request_change_logs": {
      "last_15": "15 последних",
      "all": "Все",
      "search_placeholder": "В работе, изменения, комментарий, компания",
      "table_col_action": "Действие",
      "table_col_user": "Пользователь",
      "table_col_info": "Информация",
      "table_col_when": "Когда",
      "nothing_found": "Ничего не найдено",
      "create": "Создание",
      "update": "Редактирование",
      "delete": "Удаление",
      "notify": "Уведомление",
      "comparing_logs_error": "Ошибка сравнения логов",
      "comparing_modal_header": "Сравнение логов редактирования заявки",
      "comparing_modal_change_algorithm_button": "Сравнить другим алгоритмом"
    },
    "status": {
      "edit_reason": {
        "state_the_reason": "Укажите причину запроса на редактирование",
        "no_value_error": "Необходимо указать значение",
        "max_chars_error": "Максимальная длина 10 000 символов",
        "close": "Закрыть",
        "change": "Изменить"
      },
      "cancel_reason": {
        "choose_cancellation_initiator": "Выберите инициатора отмены заявки",
        "no_value_error": "Необходимо выбрать значение",
        "close": "Закрыть",
        "change": "Изменить"
      }
    }
  },
  "titles": {
    "all": "X-Outkeep | Заявки",
    "repossession": "X-Outkeep | Заявки с изъятием",
    "requests_distribution": "X-Outkeep | Распределение заявок",
    "requests_registry": "X-Outkeep | Реестр Логиста"
  },
  "workflows": {
    "take_photo": "Сделать фото",
    "upload_from_gallery": "Загрузить из галереи",
    "retry_file_upload": "Повторить загрузку",
    "retry_file_deletion": "Повторить удаление",
    "offline_upload_pending": "Ожидает отправки",
    "offline_remove_pending": "Будет удалено",
    "offline_upload_pending_hint": "Файл сохранён локально и автоматически отправится на сервер при восстановлении соединения.",
    "offline_remove_pending_hint": "Файл помечен на удаление и будет удалён с сервера после восстановления соединения.",
    "dismiss_error": "Оставить файл. Отменить удаление",
    "photo_queue_storage_error": "Не удалось сохранить операцию для фоновой синхронизации",
    "file_invalid_type": "Недопустимый тип файла",
    "file_too_large": "Файл больше {{max}} МБ",
    "file_too_many": "Можно добавить не больше {{max}} файлов",
    "file_upload_failed": "Файл не загружен",
    "file_remove_failed": "Файл не удалён",
    "file_not_saved_locally": "Не удалось сохранить файл на устройстве",
    "file_rejected": "«{{name}}»: {{reason}}",
    "files_not_saved": "Не все файлы сохранены, форма не отправлена. Проверьте файлы с ошибкой",
    "files_queued": "Нет связи: файлы сохранены на устройстве и отправятся автоматически",
    "photo_queue_upload_failed_hint": "Автоматические попытки загрузки исчерпаны. Повторите загрузку или удалите файл.",
    "photo_queue_remove_failed_hint": "Автоматические попытки удаления исчерпаны. Повторите удаление или оставьте файл.",
    "cancel_queued_upload": "Отменить отложенную загрузку",
    "added_photos": "Добавлено {{count}} фото",
    "save_photos": "Сохранить фото?",
    "take_more_photos": "Сделать еще фото",
    "sync": "Далее",
    "final_page_header": "Завершение работы",
    "final_page_title": "Отправьте данные",
    "final_page_description": "Убедитесь на других шагах, что все заполнено корректно, и отправьте нам форму",
    "final_page_attention": "Статус заявки будет изменён на статус «Выполнено»",
    "final_page_completed": "Рабочие процессы данной заявки завершены!",
    "final_page_sync": "Сохранить и отправить",
    "preview_sent": "Просмотр (Отправлено)",
    "preview_no_rights": "Просмотр (недостаточно прав)",
    "preview_other_executor_read_only": "Эта форма для другого исполнителя. Только просмотр.",
    "start_workflow_execution": "Приступить",
    "complete_request_step": "Завершить заявку",
    "offline_form_queued": "Нет подключения к интернету. Форма сохранена на устройстве и будет отправлена при восстановлении связи",
    "offline_form_not_saved": "Нет подключения к интернету, и форму не удалось сохранить на устройстве. Данные не отправлены — повторите сохранение позже",
    "offline_completion_queued": "Нет подключения к интернету. Завершение сохранено на устройстве и будет отправлено при восстановлении связи",
    "offline_completion_not_saved": "Нет подключения к интернету, и завершение не удалось сохранить на устройстве. Повторите, когда появится связь",
    "draft_not_saved_locally": "Черновик формы не удалось сохранить на устройстве",
    "draft_discarded_version_changed": "Регламент изменился — сохранённый черновик формы не может быть восстановлен",
    "logout_unsent_title": "Есть неотправленные данные",
    "logout_unsent_message": "На устройстве неотправленных операций по регламентам: {{count}}. Они будут отправлены, когда вы снова войдёте под этим пользователем. Выйти?",
    "logout_unsent_confirm": "Выйти",
    "logout_unsent_cancel": "Отмена",
    "complete_blocked_pending": "Нельзя завершить регламенты: по заявке есть неотправленные данные ({{count}}). Дождитесь отправки и повторите",
    "deal_details_not_saved": "Детали сделки не сохранены",
    "pending_state_unknown": "Не удалось проверить неотправленные данные на устройстве. Завершение отложено — повторите позже",
    "screen_state": {
      "loading": "Загрузка регламентов…",
      "forbidden": "Нет доступа к регламентам заявки",
      "not_found": "Регламенты заявки не найдены",
      "unavailable": "Нет связи, а сохранённых данных регламентов на устройстве нет",
      "stale_offline": "Нет связи: показаны сохранённые на устройстве данные регламентов. Они могут быть устаревшими; изменения отправятся при восстановлении связи",
      "sync_pending": "Неотправленных изменений на устройстве: {{count}}. Они отправятся автоматически",
      "sync_failed": "Не удалось отправить изменения: {{count}}",
      "retry": "Повторить отправку",
      "empty": "Регламентов не найдено",
      "final_blocked_title": "Завершение недоступно, пока не отправлены данные:",
      "item_form": "Форма",
      "item_photo": "Фото",
      "item_completion": "Завершение регламентов",
      "item_pending": "ожидает отправки",
      "item_failed": "не отправлено"
    },
    "continue_workflow_execution": "Продолжить",
    "all_forms_completed": "Все формы заполнены!",
    "you_can_submit_workflows": "Вы можете завершить регламенты и отправить данные на проверку",
    "steps": "Этапы",
    "mistakes_button": "Ошибки в заявке",
    "mistakes_form": {
      "title": "Ошибки заявки {{requestNumber}}",
      "instruction": "Отметьте галочкой ошибки и заполните комментарий",
      "comment_label": "Комментарий:",
      "submit_description": "По кнопке \"Сохранить\" ошибки будут записаны в заявке и ее статус изменится на",
      "status_name": "Ошибка в заявке",
      "cancel_button": "Отмена",
      "save_button": "Сохранить",
      "save_success": "Ошибки успешно сохранены. Заявка переведена в статус \"Ошибка в заявке\"",
      "save_error": "Ошибка при сохранении ошибок заявки",
      "load_error": "Не удалось загрузить текущие ошибки заявки",
      "clear_description": "Отметок нет: по кнопке «Удалить ошибки» все ошибки заявки будут удалены",
      "clear_button": "Удалить ошибки",
      "clear_confirm_title": "Удалить ошибки заявки?",
      "clear_confirm_message": "Все ошибки заявки будут удалены",
      "clear_success": "Ошибки заявки удалены"
    },
    "events_dialog": {
      "all_header": "Логи всех регламентов",
      "open_all_button": "Логи регламентов",
      "open_button": "Показать события регламента",
      "header": "События регламента",
      "loading": "Загружаем события регламента...",
      "error_title": "Не удалось открыть историю",
      "empty_title": "Событий пока нет",
      "empty_description": "Когда по регламенту появится активность, она отобразится здесь.",
      "close": "Закрыть",
      "error_workflow_not_found": "Регламент не найден.",
      "error_load": "Не удалось загрузить события регламента.",
      "files": "Файлов",
      "default_workflow_label": "Регламент",
      "event_id_label": "ID события",
      "no_name_workflow": "Без названия",
      "system_actor_name": "Система",
      "default_event_label": "Событие",
      "default_event_status": "событие",
      "workflow_created_label": "Регламент создан",
      "workflow_created_status": "создано",
      "workflow_in_progress_label": "Регламент открыт",
      "workflow_in_progress_status": "в работе",
      "workflow_submitted_label": "Регламент отправлен",
      "workflow_submitted_status": "готово",
      "submission_invalid_label": "Валидация не пройдена",
      "submission_invalid_status": "ошибка",
      "submission_synced_label": "Форма синхронизирована",
      "submission_no_changes_status": "без изменений",
      "submission_valid_status": "валидно",
      "file_uploaded_label": "Файл добавлен",
      "file_uploaded_status": "загружено",
      "file_deleted_label": "Файл удален",
      "file_deleted_status": "удалено",
      "file_upload_group_label": "Файлы добавлены",
      "search_placeholder": "Поиск по форме, событию, файлу, ID",
      "hide_quiet_sync": "Скрыть тихие sync",
      "regulations": "Регламент",
      "all": "Все",
      "rows": "строк",
      "successful": "успешно",
      "errors": "ошибок",
      "file_based": "файловых",
      "table_time": "Время",
      "table_user": "Пользователь",
      "table_action": "Действие",
      "table_object": "Объект",
      "table_status": "Статус",
      "table_metadata": "Метаданные",
      "full_name": "ФИО",
      "workflow_short": "регл",
      "form": "форма",
      "fields": "поля",
      "more_fields": "полей",
      "files_short": "файлы",
      "more_files": "файлов",
      "device_short": "устр",
      "mobile": "моб.",
      "desktop": "дескт.",
      "form_data": "Данные формы",
      "files_section": "Файлы",
      "file_default": "Файл",
      "no_files": "нет файлов",
      "raw_log": "Сырой лог",
      "event_label": "Событие",
      "event_ids_label": "ID событий",
      "regulations_label": "Регламент",
      "valid_label": "Валидно",
      "time_utc_label": "Время UTC",
      "device_label": "Устройство",
      "no_events": "Нет событий",
      "change_search_filters": "Измените поиск или фильтры."
    },
    "errors": {
      "common": {
        "no_connection_title": "Нет подключения к интернету",
        "no_connection_message": "Данные будут отправлены автоматически после восстановления связи.",
        "fallback_message": "Попробуйте снова или обратитесь в поддержку."
      },
      "sync": {
        "default_title": "Ошибка синхронизации формы",
        "validation_title": "Обнаружены ошибки валидации",
        "file_upload_title": "Ошибка загрузки файла",
        "already_completed_title": "Форма уже завершена",
        "already_completed_message": "Эта форма уже была завершена ранее.",
        "request_not_found_title": "Заявка не найдена",
        "request_not_found_message": "Не удалось найти заявку для синхронизации формы.",
        "form_not_found_title": "Форма не найдена",
        "form_not_found_message": "Форма регламента не найдена. Обновите страницу.",
        "workflow_not_found_title": "Регламент не найден",
        "workflow_not_found_message": "Регламент не найден для этой заявки. Обновите страницу.",
        "submission_not_found_title": "Черновик формы не найден",
        "submission_not_found_message": "Сервер не нашел текущий сабмит формы. Попробуйте отправить снова.",
        "bad_next_form_title": "Некорректный следующий шаг",
        "bad_next_form_message": "Сервер отклонил переход к следующей форме. Обновите страницу.",
        "submission_mismatch_title": "Конфликт данных формы",
        "file_category_not_found_title": "Категория файлов не найдена",
        "file_category_not_found_message": "Для загружаемого файла не найдена категория файлов."
      },
      "complete": {
        "default_title": "Ошибка завершения регламентов",
        "validation_title": "Обнаружены ошибки валидации",
        "validation_message": "Исправьте ошибки в формах и повторите попытку завершения регламентов.",
        "not_all_completed_title": "Не все формы завершены",
        "not_all_completed_message": "Убедитесь, что все формы заполнены и отправлены перед завершением.",
        "already_completed_title": "Регламенты уже завершены",
        "already_completed_message": "Для этой заявки регламенты уже завершены.",
        "request_not_found_title": "Заявка не найдена",
        "request_not_found_message": "Не удалось найти заявку для завершения регламентов.",
        "workflow_request_mismatch_title": "Конфликт регламента и заявки",
        "workflow_request_mismatch_message": "Регламент не соответствует заявке. Обновите страницу и повторите.",
        "workflow_not_found_title": "Регламент не найден",
        "workflow_not_found_message": "Один из регламентов не найден. Обновите страницу и повторите.",
        "duplicate_submissions_title": "Найдены дубли форм",
        "duplicate_submissions_message": "Обнаружены дубли отправок формы. Обновите страницу и повторите."
      }
    }
  },
  "debug_panel": {
    "debug_button_hint": "Дебаг регламентов",
    "filling_button_hint": "Информация о заполнении регламентов"
  },
  "request_create": {
    "title": "Создание заявки",
    "create_button": "Создать заявку",
    "back": "Назад",
    "next": "Далее",
    "create": "Создать",
    "finish": "Завершить",
    "send_to_work": "Отправить в работу",
    "send_to_work_success": "Заявка отправлена в работу",
    "send_to_work_error": "Ошибка при отправке заявки в работу",
    "close": "Закрыть",
    "go_to_request": "Перейти к заявке",
    "success_title": "Заявка успешно создана",
    "success_number": "Номер заявки:",
    "required_title": "Заполните обязательные поля",
    "section_counterparty": "Информация о заказчике",
    "section_contract": "Информация о договоре",
    "section_lessee": "Информация о лизингополучателе",
    "section_vehicle": "Информация о транспортном средстве",
    "section_delivery": "Информация о салоне выдачи предмета лизинга",
    "section_release": "Информация о датах",
    "section_request_type": "Тип заявки",
    "section_managers": "Менеджеры",
    "section_additional": "Дополнительная информация",
    "section_executor": "Настройки исполнителя и подразделения",
    "section_products": "Товары и услуги заявки",
    "section_files": "Загрузка файлов",
    "files_hint": "Загрузите фотографии и документы по созданной заявке. Этот шаг можно завершить без файлов и перейти к сводке позже.",
    "counterparty_id": "Заказчик",
    "nearest_branch": "Точка заказчика",
    "project_number": "Номер проекта",
    "contract": "Номер договора лизинга",
    "contract_date": "Дата договора лизинга",
    "contract_planned_end_date": "Плановая дата окончания договора",
    "contract_early_end_date": "Дата досрочного окончания договора",
    "subj_name": "Наименование лизингополучателя",
    "subj_inn": "ИНН",
    "subj_fullname": "ФИО",
    "subj_phone": "Телефон",
    "release_date": "Планируемая дата выдачи",
    "release_time": "Планируемое время выдачи",
    "request_type": "Тип заявки",
    "car_brand": "Марка ТС",
    "car_vin": "VIN",
    "car_plant_number": "Заводской номер",
    "car_model": "Модель ТС",
    "car_brand_name": "Марка ТС",
    "car_year": "Год выпуска",
    "area_code": "Код субъекта (регион)",
    "delivery_address": "Адрес салона выдачи ПЛ",
    "delivery_name": "Название салона выдачи ПЛ",
    "delivery_person_name": "Представитель поставщика",
    "delivery_person_phone": "Телефон контактного лица в салоне",
    "delivery_person_email": "Email контактного лица в салоне",
    "support_manager": "ФИО менеджера сопровождения",
    "support_manager_phone": "Телефон менеджера сопровождения",
    "client_manager": "ФИО менеджера клиента",
    "client_manager_phone": "Телефон менеджера клиента",
    "client_manager_email": "Email менеджера клиента",
    "shipment_docs_address": "Адрес отправки оригиналов документов",
    "shipment_keys_address": "Адрес отправки ключей",
    "timezone": "Часовой пояс",
    "contractor": "Назначенный исполнитель",
    "contractor_subdivision": "Назначенное подразделение",
    "install_price": "Стоимость установки",
    "product": "Услуга / товар",
    "product_amount": "Количество",
    "add_product": "Добавить"
  },
  "mass_filter_input": {
    "values_count": "Значений: {{count}}",
    "over_limit": "Значений: {{count}}, максимум {{limit}} — сократите список",
    "value_too_long": "Значений длиннее {{length}} символов: {{count}} — проверьте, тот ли столбец вставлен",
    "exact_match_hint": "Поиск по набору идёт по точному совпадению",
    "values_count_chip": "{{count}} значений",
    "values_total": "… (всего {{count}})"
  }
}
